<header class="u-clearfix u-header u-header" id="sec-336a">
  <a
    [routerLink]="['/home']" routerLinkActive="router-link-active" 
    class="u-image u-logo u-image-1"
    data-image-width="1654"
    data-image-height="466"
  >
    <img src="../../assets/images/nav/logo.jpg" class="u-logo-image u-logo-image-1" /> </a
  ><img
    class="u-hidden-xs u-image u-image-default u-image-2"
    src="../../assets/images/nav/right.png"
    alt=""
    data-image-width="304"
    data-image-height="190"
    style="position: absolute;
    margin-top: -60px;
    right: 0;"
  /><img
    class="u-hidden-xs u-image u-image-default u-image-3"
    src="../../assets/images/nav/left.png"
    alt=""
    data-image-width="286"
    data-image-height="176"
    style="position: absolute;
    margin-top: -60px;"
  />
  <ul class="nav justify-content-center main-tool-bar" id="webmenu" style="margin-top: 0px; margin-bottom: 0px;">
    <li class="nav-item">
      <a class="nav-link active" [routerLink]="['/home']" routerLinkActive="router-link-active" >Home</a>
    </li>
    <li class="nav-item">
      <a class="nav-link" [routerLink]="['/about']" routerLinkActive="router-link-active" >About Us</a>
    </li>
    <li class="nav-item">
      <a class="nav-link" [routerLink]="['/services']" routerLinkActive="router-link-active" >Services</a>
    </li>
    <li class="nav-item">
      <a class="nav-link" [routerLink]="['/process']" routerLinkActive="router-link-active" >Process</a>
    </li>
    <li class="nav-item">
      <a class="nav-link" [routerLink]="['/gallery']" routerLinkActive="router-link-active" >Gallery</a>
    </li>
    <li class="nav-item">
      <a class="nav-link" [routerLink]="['/publish']" routerLinkActive="router-link-active"  >Publish</a>
    </li>
    <li class="nav-item">
      <a class="nav-link" [routerLink]="['/testimonials']" routerLinkActive="router-link-active" >Testimonials</a>
    </li>
    <li class="nav-item">
      <a class="nav-link" [routerLink]="['/contact']" routerLinkActive="router-link-active" >Contact Us</a>
    </li>
  </ul>

        <!--  -->
        <!-- <div class="u-custom-menu u-nav-container-collapse"> -->
          <div class="toggle">
            <div class="hamburger" id="hamburger"></div>
          </div>
          <div class="menu">
            <ul>
              <li><a (click)="navigate('home')" >Home</a></li>
              <li><a (click)="navigate('about')" >About</a></li>
              <li><a (click)="navigate('services')">Services</a></li>
              <li><a (click)="navigate('process')" >Process</a></li>
              <li><a (click)="navigate('gallery')" >Gallery</a></li>
              <li><a (click)="navigate('publish')" >Publish</a></li>
              <li><a (click)="navigate('testimonials')" >Testimonials</a></li>
              <li><a (click)="navigate('contact')" >Contact Us</a></li>
            </ul>
          </div>
        <!-- </div> -->
</header>

